class Data {
    constructor() {
        /* First of all we get and register all data from server */
        this.callData();

        /* Runtime / page dependent configuration types. */
        this.SETTING        = 'setting';
        this.VARIABLE       = 'variable';
        this.CONFIGURATION  = 'configuration';
        this.ROUTE          = 'route';
        this.API            = 'api';
        this.TRANSLATION    = 'translation';

        /**
         * Entities namespace.
         * @deprecated
         */
        this.entities = {};

        /**
         * Interface (part of the view) namespace.
         * @deprecated
         *
         * @type {{}}
         */
        this.interface = {};

        /* Globalize Requests */
        App.Setting     = setting       => this.getSetting(setting);
        App.Variable    = variable      => this.getVariable(variable);
    }

    /**
     *  Class coming from Action
     *  app/lib/Dwoo/plugins/functions/PluginBuildJavascriptData.php
     */
    callData() {
        this.variables = mmdata || {};
        callActionData(this);
    }

    /**
     * Registers a runtime configuration option.
     *
     * @param type string The type of the option. Use CONFIGURATION / TRANSLATION / VARIABLE / ROUTE constants.
     * @param nameOrValue string|object The name of the option or the value. If it's a value it sould be an object for extending the current value.
     * @param value mixed|undefined The value or undefined if the second parameter was a merge object.
     */
    register(type, nameOrValue, value) {
        /*
         * If the value is not defined we merge the nameOfValue object into the current key/value object.
         * Otherwise we just save the value for the type/key.
         */
        if (value === undefined) {
            var error = false;
            if (typeof nameOrValue !== 'object') {
                error = true;
            }
            if (!Array.isArray(nameOrValue)) {
                error = true;
            }
            if (error) {
                throw new Error('Only objects/arrays are allowed type: ' + type + '; ' + (typeof nameOrValue));
            } else {
                $.extend(this.variables[type], nameOrValue);
            }
        } else {
            this.variables[type][nameOrValue] = value;
        }
    }

    /**
     * Checks if a register and a property exists.
     *
     * @param type string The type to get. Use CONFIGURATION / TRANSLATION / VARIABLE / ROUTE constants.
     * @param name string The name of the property.
     * @returns boolean True if the register is available and the property exists.
     */
    has(type, name) {
        var returnValue = false;
        if (this.variables[type] !== undefined) {
            returnValue = true;
        }
        if (this.variables[type][name] !== undefined) {
            returnValue = true;
        }
        return returnValue;
    }

    /**
     * Returns the value of a runtime configuration parameter.
     *
     * @param type string The type to get. Use CONFIGURATION / TRANSLATION / VARIABLE / ROUTE constants.
     * @param name string The name of the property.
     * @returns mixed The value of the property.
     */
    get(type, name) {
        if (this.variables[type] === undefined) throw new Error('Unknown Register: ' + type);
        if (this.variables[type][name] !== undefined) {
            return this.variables[type][name];
        }
    }

    remove(type, name) {
        delete this.variables[type][name];
    }

    /**
     * Get a view variable.
     *
     * @param name The name of the variable.
     * @returns string The value of the view variable.
     */
    getVariable(name) {
        return this.get(this.VARIABLE, name);
    }

    /**
     * Get a view route.
     *
     * @param name The name of the variable.
     * @returns string The value of the view variable.
     */
    getRoute(name) {
        return this.get(this.ROUTE, name);
    }

    /**
     * Get a view route.
     *
     * @param name The name of the variable.
     * @returns string The value of the view variable.
     */
    getTranslation(name) {
        return this.get(this.TRANSLATION, name);
    }

    /**
     * Get a setting variable.
     *
     * @param name The name of the setting.
     * @returns string The value of the view setting.
     */
    getSetting(name) {
        return this.get(this.SETTING, name);
    }

    /**
     * Gets a configuration property.
     *
     * @param name The name of the configuration property.
     * @returns string The requested configuration property.
     */
    getConfiguration(name) {
        let configuration  = this.get(this.CONFIGURATION, name);
        try {
            // if it is JSON
            let value = JSON.parse(configuration);
            if (typeof value === 'object') return value;
        } catch (e) { }
        return configuration;
    }

    getApi(endpoint) {
        const values = this.get(this.API, endpoint);
        if (values) {
            this.remove(this.API, endpoint);
            return JSON.parse(values);
        }
        return undefined;
    }
}
App.Data = new Data();
// @todo: Replace all "mymuesli" calls on project to remove this line
window.mymuesli = App.Data;
